

import { Message } from 'element-ui'
import { ENV } from 'public/config'
import { entryFileVersion, grayRemoteMark, envConfigs } from './config.js'
import { getMultiModuleData } from '@/layout/utils'
import { remoteModulesConfig } from './package-list/index'

export function showErrorTips(text) {
  Message({ message: '[Remote Module]: ' + text, type: 'error', duration: 5000 })
}

export const log = function(msg, ...args) {
  console.info(`[Remote Module]: ${msg}`, ...args)
}
// 获取灰度版本标识
function getGrayModules() {
  const grayModules = sessionStorage.ERPGRAYMODULE
  return grayModules ? grayModules.split(',') : []
}
// 获取泳道环境版本号
function getMultiModuleVersion (name) {
  const multiModules = getMultiModuleData()
  let version = ''
  if (multiModules && multiModules.version.length) {
    multiModules.version.forEach(multiModuleName => {
      const remoteModuleName = `remote-module-${name}`
      if (multiModuleName.includes(remoteModuleName)) {
        const modulesVersion = multiModuleName.substr(remoteModuleName.length)
        if (Number(modulesVersion)) {
          version = modulesVersion
        }
      }
    })
  }
  return version
}
// 判断是否为灰度版本或者多版本，获取publicPath补全路径和baseUrl
function getModulePath(module) {
  try {
    const multiModuleVersion = getMultiModuleVersion(module.name)
    if (multiModuleVersion) {
      return multiModuleVersion
    }

    const grayModules = getGrayModules()
    module.isGray = grayModules.some(t => t === module.name)
    if (module.isGray) {
      return grayRemoteMark
    }
    return ''
  } catch (err) {
    console.error('getModulePath', err)
    return ''
  }
}

// 设置生产泳道环境的访问域名，减少生产环境服务器ng的压力(modulePath有值且不为灰度时才需要设置域名)
function getMultiModuleBaseUrl (path, url) {
  if (ENV === 'prd') {
    if (path && path !== grayRemoteMark) {
      return envConfigs.prd.multiModuleBaseUrl
    }
  }
  return url
}

// 补全默认entry、publicPath`
export function normalizeModule (configs = [], baseUrl, fileNamePostfix) {
  if (!baseUrl || !fileNamePostfix) {
    log('baseUrl 或 fileNamePostfix 为空')
  }
  configs.forEach(module => {
    const modulePath = getModulePath(module)
    const moduleBaseUrl = getMultiModuleBaseUrl(modulePath, baseUrl)
    if (!module.name || !module.activeRule) {
      throw new Error('[Remote Module]: module name 或 activeRule 不能为空')
    }
    if (!module.publicPath) {
      module.publicPath = `${moduleBaseUrl}/${module.name}/remote-module-${module.name}${modulePath}/` // publicPath 取决于远程模块的部署路径
    }
    if (!module.entry) {
      module.entry = `${module.publicPath}static/js/${module.name}${fileNamePostfix}.js?${entryFileVersion}`
    }
  })
  return configs
}

// 清除小包内多余的路由
// 远程包的所有路由中剔除掉不是远程包自己的路由
export function getOwnerRoutes (routes, rules) {
  return routes.filter(route => {
    return (rules.includes(route.path.slice(1)))
  })
}

// 清大包内多余的路由
// 从大包内的路由中，排除已配置远程包的路由，否则后续的addRoutes加不进来
export function filterRoutesByRule (routes, moduleConfigs) {
  if (!moduleConfigs.length) {
    return routes
  }
  try {
    const allRules = [] // 提取所有的activeRule
    moduleConfigs.forEach(config => {
      if (Array.isArray(config.activeRule)) {
        allRules.push(...config.activeRule)
      }
    })
    // allRules: ['ams','mcs']
    return routes.filter(route => {
      return !(allRules.includes(route.path.slice(1))) // /ams => ams
    })
  } catch (e) {
    console.error(e)
    return routes
  }
}

export function loadChunkFromEntryUrl(url) {
  return new Promise(function(resolve, reject) {
    let head = document.getElementsByTagName('head')[0]
    let script = document.createElement('script')
    script.setAttribute('crossorigin', '')
    script.type = 'text/javascript'
    script.charset = 'utf-8'
    script.async = true
    script.timeout = 120000
    script.src = url
    head.appendChild(script)
    script.onload = function() {
      resolve()
    }
    script.onerror = function(e) {
      reject(e)
    }
  })
}

export const getConfigFromDict = function (env) {
  try {
    if (!env) {
      return []
    }
    // const lookup = window.__ERPLOOKUP__ ? window.__ERPLOOKUP__.find(x => x.code === 'sys_frontend_remote_module') : null
    // const envMap = lookup && lookup.value
    // if (!envMap) {
    //   return []
    // }
    // const config = envMap.find(e => e.lookupCode === env) || {}
    // return config.lookupValue ? config.lookupValue.split(',') : []
    return remoteModulesConfig[env] || []
  } catch (e) {
    window._apm && window._apm('captureException', new Error(`【ERP:getConfigFromDict】${e}`))
  }
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/utils.js